import { createContext, useContext } from 'react';

export const InitialHtmlContext = createContext(false);
export const useInitialHtml = () => Boolean(useContext(InitialHtmlContext));
export const useServerHtml = () => useContext(InitialHtmlContext)?.server === true;
